import { companyShiftDetailKey } from 'queries/company/keys'

export const shiftKey = ['shift']

export const duplicateShiftsKey = [...shiftKey, 'duplicateShifts']

export const shiftForEditKey = (shiftId?: number) => [
  ...shiftKey,
  'shiftForEdit',
  shiftId,
]

export const shiftTimelineRootKey = [...shiftKey, 'shiftTimeline']

export const shiftTimelineKey = (
  startsAt?: Date,
  locationId?: number,
  positionId?: number
) => [...shiftTimelineRootKey, startsAt?.toISOString(), locationId, positionId]

export const ledShiftsKey = (shiftId?: number) => [
  ...shiftKey,
  'ledShifts',
  shiftId,
]

export const leadShiftsKey = (shiftId?: number) => [
  ...shiftKey,
  'leadShifts',
  shiftId,
]

export const shiftWorkKey = (shiftId: number) => [
  ...companyShiftDetailKey([shiftId]),
  'work',
]

export const shiftLeadEligibilityKey = (companyId?: number) => [
  ...shiftKey,
  'shiftLeadEligibility',
  companyId,
]

export const eligibleLeadShiftsKey = (shiftId?: number) => [
  ...shiftKey,
  'eligibleLeadShifts',
  shiftId,
]

export const shiftCsvKey = (
  startDate?: Date,
  endDate?: Date,
  locationId?: number,
  positionId?: number
) => ['shiftCsv', startDate, endDate, locationId, positionId]

export const employerGuidanceKey = (
  positionId: number,
  locationId: number,
  mileage?: number,
  shiftDurationHours?: number
) => [
  'shiftEditor',
  'employerGuidance',
  positionId,
  locationId,
  mileage,
  shiftDurationHours,
]

export const shiftTutorialsKey = (shiftId: number) => [
  ...shiftKey,
  'shiftTutorials',
  shiftId,
]

export const shiftTutorialKey = (shiftId: number, tutorialId?: number) => {
  return [...shiftKey, 'shiftTutorial', shiftId, tutorialId]
}

export const shouldUseBillRateKey = (positionId?: number) => [
  'shiftEditor',
  'shouldUseBillRate',
  positionId,
]
